import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Copy } from 'lucide-react';
import { FaWhatsapp, FaTelegramPlane  } from "react-icons/fa";



const BookingLinks: React.FC = () => {
  const bookingPlatforms = [
    {
      name: 'Airbnb',
      url: 'https://www.airbnb.com/rooms/23382191?guests=1&adults=1&s=67&unique_share_id=3044a98a-80c7-4b3f-9b36-ec2fb878597f',
      logo: (
        <svg viewBox="0 0 24 24" className="w-8 h-8" fill="currentColor">
          <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm7.9 16.9c-.4 1.1-1.2 2.1-2.2 2.8-.6.4-1.3.7-2 .8-.4.1-.8.1-1.2 0-.8-.1-1.5-.5-2.1-1.1-.3-.3-.6-.7-.8-1.1-.2-.4-.3-.8-.3-1.2 0-.2 0-.4.1-.6.1-.4.3-.8.6-1.1.3-.3.7-.5 1.1-.6.2 0 .4-.1.6-.1.4 0 .8.1 1.2.3.4.2.7.5 1 .8.3.3.5.7.6 1.1.1.2.1.4.1.6 0 .4-.1.8-.3 1.2-.2.4-.5.7-.8 1.1-.6.6-1.3 1-2.1 1.1-.4.1-.8.1-1.2 0-.7-.1-1.4-.4-2-.8-1-.7-1.8-1.7-2.2-2.8-.2-.6-.3-1.2-.2-1.8.1-.6.3-1.2.7-1.7.4-.5.9-.9 1.5-1.1.3-.1.6-.2.9-.2.6 0 1.2.2 1.7.5.5.3.9.7 1.2 1.2.3.5.4 1 .4 1.6 0 .3 0 .6-.1.9-.1.6-.4 1.1-.8 1.5-.4.4-.9.7-1.5.8-.3.1-.6.1-.9 0-.6-.1-1.1-.4-1.5-.8-.2-.2-.4-.4-.5-.7-.1-.3-.2-.6-.1-.9 0-.2.1-.4.2-.6.2-.4.5-.7.9-.9.2-.1.4-.1.6-.1.4 0 .7.1 1 .3.3.2.5.5.6.8.1.2.1.4.1.6 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.2 0-.4 0-.6-.1-.3-.1-.5-.3-.7-.5-.1-.1-.2-.3-.2-.4 0-.1 0-.3.1-.4.1-.2.3-.3.5-.4.1 0 .2 0 .3 0 .2 0 .3.1.4.2.1.1.1.2.1.3 0 .1 0 .2-.1.3-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3.1-.1.2-.1.3-.1.1 0 .2 0 .3.1.2.1.3.3.4.5.1.2.1.4 0 .6-.1.4-.4.7-.8.8-.2.1-.4.1-.6.1-.4 0-.8-.2-1.1-.5-.3-.3-.5-.7-.5-1.1 0-.2 0-.4.1-.6.1-.4.3-.8.6-1.1.3-.3.7-.5 1.1-.6.2 0 .4-.1.6-.1.4 0 .8.1 1.2.3.4.2.7.5 1 .8.3.3.5.7.6 1.1.1.2.1.4.1.6 0 .4-.1.8-.3 1.2-.2.4-.5.7-.8 1.1-.6.6-1.3 1-2.1 1.1-.4.1-.8.1-1.2 0-.7-.1-1.4-.4-2-.8-1-.7-1.8-1.7-2.2-2.8-.2-.6-.3-1.2-.2-1.8.1-.6.3-1.2.7-1.7.4-.5.9-.9 1.5-1.1.3-.1.6-.2.9-.2.6 0 1.2.2 1.7.5.5.3.9.7 1.2 1.2.3.5.4 1 .4 1.6 0 .3 0 .6-.1.9-.1.6-.4 1.1-.8 1.5-.4.4-.9.7-1.5.8-.3.1-.6.1-.9 0-.6-.1-1.1-.4-1.5-.8-.2-.2-.4-.4-.5-.7-.1-.3-.2-.6-.1-.9 0-.2.1-.4.2-.6.2-.4.5-.7.9-.9.2-.1.4-.1.6-.1.4 0 .7.1 1 .3.3.2.5.5.6.8.1.2.1.4.1.6 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.2 0-.4 0-.6-.1-.3-.1-.5-.3-.7-.5-.1-.1-.2-.3-.2-.4 0-.1 0-.3.1-.4.1-.2.3-.3.5-.4.1 0 .2 0 .3 0 .2 0 .3.1.4.2.1.1.1.2.1.3z"/>
        </svg>
      ),
      color: 'bg-[#FF5A5F] hover:bg-[#E04E53]',
      description: 'Book directly through Airbnb'
    },
    {
      name: 'Booking.com',
      url: 'https://www.booking.com/hotel/lk/dinoos-we-igama.html?aid=356980&label=gog235jc-1FCAsohQFCD2Rpbm9vcy13ZS1pZ2FtYUgzWANohQGIAQGYATG4ARfIAQzYAQHoAQH4AQKIAgGoAgO4Aq-tg8MGwAIB0gIkODc3NmZjMzYtY2ZiZi00NjYzLWI2MDUtYWU0ZGNjYTA3ODBj2AIF4AIB&sid=617643db4baee4d798e3cea18a0ccdb4&age=11&age=13&all_sr_blocks=317068304_335415289_0_0_0&checkin=2025-07-01&checkout=2025-07-09&dest_id=-2240150&dest_type=city&dist=0&group_adults=5&group_children=2&hapos=1&highlighted_blocks=317068304_335415289_0_0_0&hpos=1&matching_block_id=317068304_335415289_0_0_0&no_rooms=2&req_adults=5&req_age=11&req_age=13&req_children=2&room1=A%2CA%2C13&room2=A%2CA%2CA%2C11&sb_price_type=total&sr_order=popularity&sr_pri_blocks=317068304_335415289_0_0_0__120000&srepoch=1751179450&srpvid=01ee2f59b1a40294&type=total&ucfs=1&',
      logo: (
        <svg viewBox="0 0 24 24" className="w-8 h-8" fill="currentColor">
          <path d="M12.1 2.1c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm4.8 15.8H7.1c-.4 0-.7-.3-.7-.7V6.8c0-.4.3-.7.7-.7h9.8c.4 0 .7.3.7.7v10.4c0 .4-.3.7-.7.7z"/>
          <path d="M8.5 8.5h7v1.5h-7zm0 2.5h7v1.5h-7zm0 2.5h5v1.5h-5z"/>
        </svg>
      ),
      color: 'bg-[#003580] hover:bg-[#002147]',
      description: 'Reserve through Booking.com'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg p-8 border border-earth-beige">
      <h4 className="text-2xl font-serif font-semibold text-earth-brown mb-6 text-center">
        Book Your Stay
      </h4>
      <h6 className="text-2xl font-serif font-semibold text-earth-brown mb-6 text-center">
        Contact Directly
      </h6>
      <p className="text-gray-600 text-center mb-8">
  Phone:{" "}
  <a
    href="tel:+94 767996996"
    className="text-blue-600 hover:underline"
  >
    +94 (767) 996-996
  </a>
  <Copy
    className="inline-block w-4 h-4 ml-2 cursor-pointer text-gray-500 hover:text-gray-700"
    onClick={() => navigator.clipboard.writeText("+94777336354")}
  />
  <br />

  Phone:{" "}
  <a
    href="tel:+94777336354"
    className="text-blue-600 hover:underline"
  >
    +94 (777) 336-354
  </a>
  <Copy
    className="inline-block w-4 h-4 ml-2 cursor-pointer text-gray-500 hover:text-gray-700"
    onClick={() => navigator.clipboard.writeText("+94777336354")}
  />
  <br />
  
  Email:{" "}
  <a
    href="mailto:dinoosluxuries@gmail.com"
    className="text-blue-600 hover:underline"
  >
    dinoosluxuries@gmail.com
  </a>
  <Copy
    className="inline-block w-4 h-4 ml-2 cursor-pointer text-gray-500 hover:text-gray-700"
    onClick={() => navigator.clipboard.writeText("dinoosluxuries@gmail.com")}
  />
</p>
      <div className="text-center space-y-3 space-x-3">
        <a
          href="https://wa.me/94777336354"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-white bg-green-600 hover:bg-green-700 font-medium px-4 py-2 rounded-md transition-colors duration-200"
        >
          <FaWhatsapp className="w-5 h-5 " />
          Contact on WhatsApp
        </a>
         <a
          href="https://t.me/VillaDinoos"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-white bg-[#229ED9] hover:bg-[#1d8bbd] font-medium px-4 py-2 rounded-md transition-colors duration-200"
        >
          <FaTelegramPlane className="w-5 h-5" />
          Contact on Telegram
        </a>
      </div>
     <br />
      <p className="text-gray-600 text-center mb-8">
        Choose your preferred booking platform
      </p>
      
      <div className="space-y-4">
        {bookingPlatforms.map((platform, index) => (
          <motion.a
            key={platform.name}
            href={platform.url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className={`${platform.color} text-white rounded-lg p-4 flex items-center justify-between transition-all duration-300 hover:shadow-lg transform hover:scale-105 group`}
          >
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0">
                {platform.logo}
              </div>
              <div>
                <h4 className="font-semibold text-lg">{platform.name}</h4>
                <p className="text-sm opacity-90">{platform.description}</p>
              </div>
            </div>
            <ExternalLink className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </motion.a>
        ))}
      </div>

      <div className="mt-8 p-4 bg-olive-50 rounded-lg border border-olive-200">
        <div className="flex items-center space-x-2 text-olive-700">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <span className="font-medium">Best Rate Guarantee</span>
        </div>
        <p className="text-sm text-olive-600 mt-2">
          We offer competitive rates across all platforms. Contact us directly for special offers and extended stays.
        </p>
      </div>
    </div>
  );
};

export default BookingLinks;